var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgPhone = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.19544 9.16668C2.2792 7.61439 1.77507 6.00896 1.51322 3.93208C1.37 2.79612 2.29489 1.83334 3.43985 1.83334V1.83334C4.35686 1.83334 5.15619 2.45744 5.37859 3.34707L5.43337 3.56615C5.50285 3.84409 5.53759 3.98306 5.56153 4.11682C5.75406 5.19284 5.49785 6.30078 4.85247 7.18302C4.77224 7.2927 4.68001 7.40231 4.49556 7.62152L3.19544 9.16668ZM3.19544 9.16668C4.16551 10.8102 5.48911 12.1638 7.10541 13.1667M7.10541 13.1667C8.63543 14.1161 10.8349 14.9317 12.7534 15.1635C12.9045 15.1818 12.5267 15.1361 12.6272 15.1381C13.4884 15.1552 14.5704 14.196 14.6567 13.339C14.6668 13.239 14.6668 13.2393 14.6668 13.2392V13.2392C14.6668 13.0683 14.6668 12.9828 14.6606 12.9042C14.5976 12.1049 14.0632 11.4205 13.303 11.1654C13.2283 11.1404 13.1429 11.119 12.972 11.0763L12.8634 11.0491C12.5197 10.9632 12.3479 10.9203 12.1809 10.8932C11.2247 10.7385 10.2449 10.936 9.42326 11.449C9.27978 11.5386 9.13799 11.6447 8.85443 11.8571L7.10541 13.1667Z",
    stroke: "#6E707A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPhone);
export default ForwardRef;